import { SxProps, Theme } from "@mui/material/styles";

const styles: SxProps<Theme> = [
  {
    "&.containerFlex": {
      display: "flex",
      maxWidth: "880px",
      padding: "48px 12px 48px 12px",
      marginLeft: "auto",
      marginRight: "auto",
      position: "relative",
      "& h4": {
        fontSize: 15,
      },
    },
    "& .description": {
      //  maxWidth: 400,
      marginLeft: "24px",
      "& p": {
        marginBottom: 3,
      },
    },
  },
];

export default styles;
